if (!customElements.get('two-panel-content')) {
  customElements.define(
    'two-panel-content',
    class TwoPanelContent extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.panels = [...this.querySelectorAll('.two-panel-content__panel')];
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleSectionLoad = this.handleSectionLoad.bind(this);
        this.handleSectionUnload = this.handleSectionUnload.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);

        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
        document.addEventListener('shopify:section:unload', this.handleSectionUnload);
        this.reduceMotion.addEventListener('change', this.handleMotionChange);

        this.classList.add('tpc--js');
        this.setupObserver();
        this.updateOverflowState();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateOverflowState());
          this.resizeObserver.observe(this);
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      setupObserver() {
        this.observer?.disconnect();

        if (this.reduceMotion.matches || !('IntersectionObserver' in window)) {
          this.revealPanels();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            });
          },
          { threshold: 0.15 }
        );

        this.panels
          .filter((panel) => panel.dataset.animate === 'true')
          .forEach((panel) => this.observer.observe(panel));
      }

      handleMotionChange() {
        this.setupObserver();
      }

      handleBlockSelect(event) {
        if (!this.matchesSection(event)) return;

        const blockId = event.detail?.blockId;
        const panel = this.panels.find((item) => item.dataset.blockId === blockId);
        if (!panel) return;

        panel.classList.add('is-revealed');
        panel.scrollIntoView({ behavior: this.reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      }

      handleSectionLoad(event) {
        if (!this.matchesSection(event)) return;
        this.panels = [...this.querySelectorAll('.two-panel-content__panel')];
        this.setupObserver();
        this.updateOverflowState();
      }

      handleSectionUnload(event) {
        if (!this.matchesSection(event)) return;
        this.teardown();
      }

      matchesSection(event) {
        const sectionId = event.detail?.sectionId;
        return !sectionId || sectionId === this.dataset.sectionId;
      }

      revealPanels() {
        this.panels.forEach((panel) => panel.classList.add('is-revealed'));
      }

      updateOverflowState() {
        this.dataset.hasOverflow = this.scrollWidth > this.clientWidth + 1 ? 'true' : 'false';
      }

      teardown() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        document.removeEventListener('shopify:section:unload', this.handleSectionUnload);
        this.reduceMotion?.removeEventListener('change', this.handleMotionChange);
        this.classList.remove('tpc--js');
        this.dataset.initialized = 'false';
      }
    }
  );
}
